<template>
  <v-container>
    <!-- Header -->
    <v-row class="justify-center">
      <v-flex lg1 md1 sm5 xs5>
        <v-img height="150px" width="150px" src="../assets/logo1.png"></v-img>
      </v-flex>
      <div class="text-center mt-0 changefont">Tai Kitchen Restaurant <br> (Nay Pyi Taw)</div>
    </v-row>

    <v-row class="justify-center mb-5 white--text heading-1">
      <div>
        +95-67-3422282 <br>+95-9-43178136<br> +95-9-964422282<br>
       </div>
    </v-row>

    <v-row class="justify-center mb-5 white--text heading-1">
      <div>
         <v-icon right class="white--text pl-0 pr-2">email</v-icon>
        taikitchen@tungapurihotel.com</div>
    </v-row>
    <!-- Special Menu -->
    <v-row class="justify-center">
      <v-flex xs12 lg8 md10>
        <v-card class="mx-auto" max-width="700" elevation="20" router-link to="/chefSpecialMenu">
          <v-img class="white--text align-end" height="300px"  :src="Documents().data().imageUrl">
            <v-card-title align-top class="subtitle-1 justify-center">Chef's Special Menu</v-card-title>
          </v-img>
        </v-card>
      </v-flex>
    </v-row>

    <!-- Menu title -->
    <div class="text-center pt-5 pb-5 white--text menufont">Menu</div>

    <!-- Menu -->
    <!-- First row -->
    <v-row class="justify-center">
      <v-flex lg3 md4 sm4 xs5>
        <v-card class="mb-5 mx-auto align-center" id="rounded-card" max-width="250" router-link to="/tkSpecialMenu">
          <v-img
            gradient="to top right, rgba(100,115,201,.2), rgba(25,32,72,.2)"
            class="white--text align-end"
            height="150px"
            src="../assets/a.jpg"
          ></v-img>
          <v-card-title class="subtitle-1 justify-center black white--text">TK Special<br> Menu</v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs1 hidden-md-and-up></v-flex>

      <v-flex lg3 md4 sm4 xs5>
        <v-card class="mb-5 mx-auto" id="rounded-card" max-width="250" router-link to="/drinkSpecialMenu">
          <v-img
            gradient="to top right, rgba(100,115,201,.2), rgba(25,32,72,.2)"
            class="white--text align-end"
            height="150px"
            src="../assets/DSpecial.jpg"
          ></v-img>
          <v-card-title align-top class="subtitle-1 justify-center white--text black">Drink Special<br> Menu</v-card-title>
        </v-card>
      </v-flex>
    </v-row>

    <!-- Second row -->
    <v-row class="justify-center">
      <v-flex lg3 md4 sm4 xs5>
        <v-card class="mb-5 mx-auto align-center" id="rounded-card" max-width="250" router-link to="/appetizer">
          <v-img
            gradient="to top right, rgba(100,115,201,.2), rgba(25,32,72,.2)"
            class="white--text align-end"
            height="150px"
            src="../assets/Appetizer.jpg"
          ></v-img>
          <v-card-title align-top class="subtitle-1 justify-center white--text black">Appetizer</v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs1 hidden-md-and-up></v-flex>

     <v-flex lg3 md4 sm4 xs5>
        <v-card class="mb-5 mx-auto" id="rounded-card" max-width="250" router-link to="/side_dish">
          <v-img
            gradient="to top right, rgba(100,115,201,.2), rgba(25,32,72,.2)"
            class="white--text align-end"
            height="150px"
            src="../assets/SideDish.jpg"
          ></v-img>
          <v-card-title align-top class="subtitle-1 justify-center white--text black">Side Dish</v-card-title>
        </v-card>
      </v-flex>
    </v-row>

    <!-- Third row -->
    <v-row class="justify-center">
      <v-flex lg3 md4 sm4 xs5>
        <v-card class="mb-5 mx-auto align-center" id="rounded-card" max-width="250" router-link to="/salad">
          <v-img
            gradient="to top right, rgba(100,115,201,.2), rgba(25,32,72,.2)"
            class="white--text align-end"
            height="150px"
            src="../assets/Salad.jpg"
          ></v-img>
          <v-card-title
            align-top
            class="subtitle-1 justify-center white--text black"
          >Salad</v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs1 hidden-md-and-up></v-flex>

      <v-flex lg3 md4 sm4 xs5>
        <v-card class="mb-5 mx-auto" id="rounded-card" max-width="250" router-link to="/soup">
          <v-img
            gradient="to top right, rgba(100,115,201,.2), rgba(25,32,72,.2)"
            class="white--text align-end"
            height="150px"
            src="../assets/Soup.jpg"
          ></v-img>
          <v-card-title align-top class="subtitle-1 justify-center white--text black">Soup</v-card-title>
        </v-card>
      </v-flex>
    </v-row>

    <!-- Fourth row -->
    <v-row class="justify-center">
      <v-flex lg3 md4 sm4 xs5>
        <v-card class="mb-5 mx-auto align-center" id="rounded-card" max-width="250" router-link to="/seafood"> 
          <v-img
            gradient="to top right, rgba(100,115,201,.2), rgba(25,32,72,.2)"
            class="white--text align-end"
            height="150px"
            src="../assets/Seafoods.jpg"
          ></v-img>
          <v-card-title align-top class="subtitle-1 justify-center white--text black">seafood</v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs1 hidden-md-and-up></v-flex>

      <v-flex lg3 md4 sm4 xs5>
        <v-card class="mb-5 mx-auto" id="rounded-card" max-width="250" router-link to="/fish">
          <v-img
            gradient="to top right, rgba(100,115,201,.2), rgba(25,32,72,.2)"
            class="white--text align-end"
            height="150px"
            src="../assets/Fish.jpg"
          ></v-img>
          <v-card-title align-top class="subtitle-1 justify-center white--text black">Fish</v-card-title>
        </v-card>
      </v-flex>
    </v-row>

    <!-- Fifth row -->
    <v-row class="justify-center">
      <v-flex lg3 md4 sm4 xs5>
        <v-card class="mb-5 mx-auto align-center" id="rounded-card" max-width="250" router-link to="/chicken">
          <v-img
            gradient="to top right, rgba(100,115,201,.2), rgba(25,32,72,.2)"
            class="white--text align-end"
            height="150px"
            src="../assets/Chicken.png"
          ></v-img>
          <v-card-title align-top class="subtitle-1 justify-center white--text black">Chicken</v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs1 hidden-md-and-up></v-flex>

      <v-flex lg3 md4 sm4 xs5>
        <v-card class="mb-5 mx-auto" id="rounded-card" max-width="250" router-link to="/pork">
          <v-img
            gradient="to top right, rgba(100,115,201,.2), rgba(25,32,72,.2)"
            class="white--text align-end"
            height="150px"
            src="../assets/Pork.jpg"
          ></v-img>
          <v-card-title align-top class="subtitle-1 justify-center white--text black">Pork</v-card-title>
        </v-card>
      </v-flex>
    </v-row>

    <!-- Sixth row -->
    <v-row class="justify-center">
      <v-flex lg3 md4 sm4 xs5>
        <v-card class="mb-5 mx-auto align-center" id="rounded-card" max-width="250" router-link to="/duck">
          <v-img
            gradient="to top right, rgba(100,115,201,.2), rgba(25,32,72,.2)"
            class="white--text align-end"
            height="150px"
            src="../assets/Duck.jpg"
          ></v-img>
          <v-card-title align-top class="subtitle-1 justify-center white--text black">Duck</v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs1 hidden-md-and-up></v-flex>

      <v-flex lg3 md4 sm4 xs5>
        <v-card class="mb-5 mx-auto" id="rounded-card" max-width="250" router-link to="/vegetable">
          <v-img
            gradient="to top right, rgba(100,115,201,.2), rgba(25,32,72,.2)"
            class="white--text align-end"
            height="150px"
            src="../assets/Vegetable.jpg"
          ></v-img>
          <v-card-title align-top class="subtitle-1 justify-center white--text black">Vegetable</v-card-title>
        </v-card>
      </v-flex>
    </v-row>

    <!-- seventh row -->
    <v-row class="justify-center">
      <v-flex lg3 md4 sm4 xs5>
        <v-card class="mb-5 mx-auto align-center" id="rounded-card" max-width="250" router-link to="/dessert">
          <v-img
            gradient="to top right, rgba(100,115,201,.2), rgba(25,32,72,.2)"
            class="white--text align-end"
            height="150px"
            src="../assets/Dessert.jpg"
          ></v-img>
          <v-card-title align-top class="subtitle-1 justify-center white--text black">Dessert</v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs1 hidden-md-and-up></v-flex>

      <v-flex lg3 md4 sm4 xs5>
        <v-card class="mb-5 mx-auto" id="rounded-card" max-width="250" router-link to="/drink">
          <v-img
            gradient="to top right, rgba(100,115,201,.2), rgba(25,32,72,.2)"
            class="white--text align-end"
            height="150px"
            src="../assets/dsmenu.jpg"
          ></v-img>
          <v-card-title align-top class="subtitle-1 justify-center white--text black">Drink</v-card-title>
        </v-card>
      </v-flex>
    </v-row>

    <v-row class="justify-center">
      <div>Copyright © 2020 www.taikitchens.com.All rights reserved.<br> 
      Design and Develop by <a href="https://www.facebook.com/candys.doll.52/">Min Thant.</a></div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  methods: {
    Documents() {
      return this.$store.getters.getImages[0];
    },
  },
  beforeCreate(){
    this.$store.commit("getImage", "Chef's Special Menu");
  },
}
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Dancing+Script&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300&family=Dancing+Script&display=swap");
#rounded-card {
  border-radius: 20px;
}
.changefont {
  /* font-family: "Dancing Script", cursive; */
  /* font-family: "Cormorant Garamond", serif; */
  font-size: 2rem;
  font-weight: bold;
  color: white;
}
.menufont {
  font-family: "Cormorant Garamond", serif;
  font-weight: bolder;
  font-size: 1.5rem;
}
</style>
